// extracted by mini-css-extract-plugin
export default {"coldStartBanner":"ColdStartNotificationBanner_coldStartBanner__SlGco","bannerContents":"ColdStartNotificationBanner_bannerContents__LXqMw"};